import { apiClient } from '../lib/api/client';

export interface SubscriptionStatus {
    plan: 'free' | 'standard' | 'premium';
    status: string;
    cancel_at_period_end: boolean;
    expires_at: string | null;
}

export const stripeService = {
    async createCheckout(planKey: 'standard' | 'premium'): Promise<string> {
        const origin      = window.location.origin;
        const successUrl  = `${origin}/dashboard/credits?payment=success`;
        const cancelUrl   = `${origin}/dashboard/credits?payment=cancelled`;

        const data = await apiClient.post<{ checkout_url: string }>('/api/stripe/checkout', {
            plan_key:    planKey,
            success_url: successUrl,
            cancel_url:  cancelUrl,
        });
        return data.checkout_url;
    },

    async getSubscription(): Promise<SubscriptionStatus> {
        return apiClient.get<SubscriptionStatus>('/api/stripe/subscription');
    },

    async createPortal(): Promise<string> {
        const returnUrl = `${window.location.origin}/dashboard/credits`;
        const data = await apiClient.post<{ portal_url: string }>('/api/stripe/portal', {
            return_url: returnUrl,
        });
        return data.portal_url;
    },
};
